<script setup>
import Alert from "@/components/AlertModal.vue";
import CompNavbar from "@/components/CompNavbar.vue";
import CompFooter from "@/components/CompFooter.vue";
import CookiesPopup from '@/components/CookiesPopup.vue'
import PoliticaPrivacidade from '@/components/PoliticaPrivacidade.vue'
</script>

<template>
  <CompNavbar /> 
  <router-view :key="$route.fullPath" /> 
  <CompFooter v-if="!$route.meta?.withoutFooter"/>
  <Alert />
  <CookiesPopup />
  <PoliticaPrivacidade />
</template>
